import { motion } from "framer-motion";
import { IMAGES } from "@/constants/site";
import { useLanguage } from "@/i18n/LanguageContext";

const cardImages = [IMAGES.turnkey, IMAGES.construction, IMAGES.renovation, IMAGES.office];
const cardAlts = ["Turnkey Interiors", "Construction", "Renovation", "Office & Shop Interiors"];

export const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-24 lg:py-32 bg-[#1A1412]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-[#D4AF37] tracking-[0.4em] uppercase text-sm mb-4">{t.services.eyebrow}</p>
          <h2 className="font-heading text-4xl sm:text-5xl text-[#FDFBF7] max-w-2xl" data-testid="services-heading">
            {t.services.heading}
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          {t.services.items.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group relative overflow-hidden border border-[#D4AF37]/20 bg-[#2A211D] hover:-translate-y-1 hover:border-[#D4AF37]/50 transition-all duration-300"
              data-testid={`service-card-${i + 1}`}
            >
              <div className="h-64 overflow-hidden">
                <img
                  src={cardImages[i]}
                  alt={cardAlts[i]}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-8 lg:p-10">
                <h3 className="font-heading text-2xl lg:text-3xl text-[#D4AF37]">{s.title}</h3>
                <p className="mt-4 text-[#B8A99A] leading-relaxed text-sm md:text-base">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
